import React from 'react'
import { useTranslation } from "react-i18next";
import { Grid, SvgIcon } from '@material-ui/core';

function LoginForm(props) {
    const { t, ready } = useTranslation();

    if (!ready) {
        return null;
    }

    return (
        <>
            <Grid item xs={12} container className='loginForm-container'>
                {/* EMAIL FIELD */}
                <Grid item xs={12} className="loginForm-input-container">
                    <label htmlFor="email" className="loginForm-input-label">{t("loginView.placeholderEmail")}</label>
                    <div className='loginForm-input-wrapper'>
                        <input
                            type="text"
                            className="loginForm-input-field"
                            id="email"
                            value={props.email}
                            autoFocus={props.email ? false : true}
                            onChange={(e) => props.onHandleGeneralChange(e)}
                            onKeyDown={(e) => props.onHandleLoginKeypress(e)}
                        />
                    </div>
                </Grid>

                {/* PASSWORD FIELD */}
                <Grid item xs={12} className="loginForm-input-container">
                    <label htmlFor="password" className="loginForm-input-label">{t("loginView.placeholderPassword")}</label>
                    <div className='loginForm-input-wrapper'>
                        <input
                            type="password"
                            className="loginForm-input-field loginForm-input-password"
                            id="password"
                            value={props.password}
                            autoFocus={props.email ? true : false}
                            onChange={(e) => props.onHandleGeneralChange(e)}
                            onKeyDown={(e) => props.onHandleLoginKeypress(e)}
                        />

                        {/* EYE ICON */}
                        <button className='loginForm-showPasswordBtn' onClick={props.onHandleShowPassword}>
                            <SvgIcon
                                className={`loginForm-input-icon ${props.loginShowPasswordIcon}`}
                            >
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                            </SvgIcon>
                        </button>
                    </div>

                    {/* FORGOT PASSWORD BUTTON */}
                    {
                        props.hideTemplatesInvitedColaborator !== false
                            ? null
                            : <button
                                className='loginForm-forgotPasswordBtn'
                                onClick={() => props.onHandleSelectTemplate("forgotPassword")}
                            >
                                {t("loginView.labelLinkForggotPassword")}
                            </button>
                    }
                </Grid>
            </Grid>

            {/* ACTIONS */}
            <Grid item xs={12}>
                <button
                    className="loginForm-primaryBtn"
                    onClick={(e) => props.onHandleLogin(e)}
                >
                    {props.loading
                        ? <span className="preloader"></span>
                        : t("loginView.buttonLogIn")
                    }
                </button>
            </Grid>

            {
                props.hideTemplatesInvitedColaborator !== false
                    ? null
                    : <>
                        <Grid item xs={12}>
                            <hr />
                        </Grid>

                        <Grid item xs={12}>
                            <button
                                className="loginForm-secondaryBtn"
                                onClick={() => props.onHandleSelectTemplate("register")}
                            >
                                {t("loginView.createAccount")}
                            </button>
                        </Grid>
                    </>
            }
        </>
    )
}

export default LoginForm